import React from "react";
import { Stack } from "@mui/material";
import {
  EditButton,
  CancelButton,
  ApproveButton,
  RejectButton,
} from "./Styles/Buttons";
import { ACTION } from "./constants";

const ActionContainer = ({ children, baseStyles }) => (
  <div style={baseStyles?.dataCell}>
    <Stack direction="row" spacing={1}>
      {children}
    </Stack>
  </div>
);

function AiSkuMappingActions({
  decideAiSkuMapping,
  decisionState,
  isEditing,
  setIsEditing,
  baseStyles = { dataCell: {} },
}) {
  const isUndecided = decisionState === ACTION.UNDECIDED;
  const isApproved = decisionState === ACTION.APPROVE;
  const isRejected = decisionState === ACTION.REJECT;

  // ------------------ EDITING MODE ------------------
  if (isEditing) {
    if (isApproved) {
      return (
        <ActionContainer baseStyles={baseStyles}>
          <CancelButton onClick={() => setIsEditing(false)} />
          <RejectButton
            onClick={() => {
              decideAiSkuMapping(ACTION.REJECT);
              setIsEditing(false);
            }}
          />
        </ActionContainer>
      );
    } else if (isRejected) {
      return (
        <ActionContainer baseStyles={baseStyles}>
          <CancelButton onClick={() => setIsEditing(false)} />
          <ApproveButton
            onClick={() => {
              decideAiSkuMapping(ACTION.APPROVE);
              setIsEditing(false);
            }}
          />
        </ActionContainer>
      );
    }
  }

  // ------------------ UNDECIDED ------------------
  else if (isUndecided) {
    return (
      <ActionContainer baseStyles={baseStyles}>
        <RejectButton
          onClick={() => {
            decideAiSkuMapping(ACTION.REJECT);
          }}
        />
        <ApproveButton
          onClick={() => {
            decideAiSkuMapping(ACTION.APPROVE);
          }}
        />
      </ActionContainer>
    );
  }

  // ------------------ DECIDED (Show Edit) ------------------
  else {
    return (
      <ActionContainer baseStyles={baseStyles}>
        <EditButton onClick={() => setIsEditing(true)} />
      </ActionContainer>
    );
  }
}

export default AiSkuMappingActions;
